import { Clipboard, Linking } from 'react-native';
import { ActionSheetOption } from '@shared/components/ActionSheet';
import { useToast } from '@shared/components/toast';
import { useBoolean } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';

interface ShowUrlActionSheetState {
  isOpen: boolean;
  openMenu: VoidFunction;
  closeMenu: VoidFunction;
  menuOptions: ActionSheetOption[];
  title: string;
}

export function useShowUrlActionSheet({ url }: { url: string }): ShowUrlActionSheetState {
  const toast = useToast();
  const [isOpen, openMenu, closeMenu] = useBoolean();

  const menuOptions: ActionSheetOption[] = [
    {
      title: i18n('workflowTemplate.component.url.actionButtonsSheet.openInBrowser'),
      onPress: () => {
        Linking.openURL(url);
      },
    },
    {
      title: i18n('workflowTemplate.component.url.actionButtonsSheet.copyLink'),
      onPress: () => {
        Clipboard.setString(url);
        toast.show({
          icon: 'check-filled',
          message: i18n('workflowTemplate.component.url.actionButtonsSheet.copiedToClipboard'),
        });
      },
    },
  ];

  return {
    isOpen,
    openMenu,
    closeMenu,
    menuOptions,
    title: url,
  };
}
